'use strict';
module.exports = require('../../full/reflect');
